<template>
    <!-- Delete linked file, on request or comment -->
    <v-dialog
      v-model="dialog"
      max-width="750px"
    >
    <v-card>
        <v-card-title class="warning">
            <h2>
                <v-icon dark class="mr-2">warning</v-icon>
                <span>Supprimer un fichier joint</span>
            </h2>
            <v-spacer></v-spacer>
            <v-btn small icon @click="dialog = false">
                <v-icon dark>close</v-icon>
            </v-btn>
        </v-card-title>
        <div class="pa-3">
            <p>Êtes-vous sur de vouloir supprimer le Fichier <template v-if="item.label">suivant :</template></p>
            <ul class="ml-3" v-if="item.label">
                <li>
                    {{ item.label }}
                </li>
            </ul>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" small round outline @click="dialog = false">Annuler</v-btn>
            <v-btn color="warning" small round text-color="white" @click="onValidate" :loading="loading">Valider</v-btn>
        </v-card-actions>
    </v-card>

    </v-dialog>

</template>

<script>
export default {
    data() {
        return {
            dialog:     false,
            item:       '',
            entity:     '',
            entity_id:  '',
            loading: false
        }
    },
    methods: {
        // when modal is open
        open(field,item,entity_id) {
            this.dialog = true
            this.entity = field
            this.item = item
            this.entity_id = entity_id
        },
        // when form is validate
        onValidate() {
            this.loading = true
            if(this.item.id) {
                this.axios.delete(`/api/${this.entity}/${this.entity_id}/file/${this.item.id}`)
                .then(response => {
                    this.$emit('deleted',this.entity_id,this.item.id)
                    this.dialog = false
                    this.loading = false
                })
            } else {
                this.$emit('deleted',this.entity_id,this.item)
                this.dialog = false
                this.loading = false
            }

        },

        onClose() {
            // reset the form on close
            if(this.$refs.form) {
                this.$refs.form.reset()
            }
            this.dialog = false
            this.loading = false
        },
    },
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>
.card{
    .card__title{
        h2 {
            color:#FFF
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/files/DeleteLinkedFiles.vue